import { useEffect } from 'react';
import { useConfirm } from './ui/ConfirmDialog';
import { useI18n } from '../utils/i18n';
import { TERMIN_ABSAGE_EVENT } from '../services/terminAbsage';

// #554: Dialog zur Rueckfrage aus services/terminAbsage.js. Rendert selbst
// nichts, der Dialog kommt aus dem ConfirmProvider.
const TerminAbsageRueckfrage = () => {
  const confirm = useConfirm();
  const { t, getLocale } = useI18n();

  useEffect(() => {
    const onFrage = (e) => {
      e.preventDefault(); // signalisiert: Rueckfrage uebernommen
      const { termine = [], antworte } = e.detail || {};
      const locale = typeof getLocale === 'function' ? getLocale() : undefined;
      const liste = termine.map((termin) => {
        const wann = termin.start ? new Date(termin.start).toLocaleString(locale, { dateStyle: 'short', timeStyle: 'short' }) : '';
        const wer = (termin.teilnehmer || []).map((p) => p.name || p.address).join(', ');
        return [wann, termin.betreff].filter(Boolean).join(' ') + (wer ? ` (${wer})` : '');
      }).join('; ');
      confirm({
        title: t('terminAbsage.title', 'Termin mit Teilnehmern'),
        message: t(
          'terminAbsage.message',
          'Zu diesem Ticket gibt es einen Termin mit Teilnehmern: {{liste}}. Wenn Sie die Zuweisung entfernen, wird der Termin gelöscht, und die Teilnehmer bekommen eine Absage.',
          { liste }
        ),
        confirmLabel: t('terminAbsage.confirm', 'Trotzdem entfernen'),
        danger: true
      }).then((ja) => { if (antworte) antworte(!!ja); });
    };
    window.addEventListener(TERMIN_ABSAGE_EVENT, onFrage);
    return () => window.removeEventListener(TERMIN_ABSAGE_EVENT, onFrage);
  }, [confirm, t, getLocale]);

  return null;
};

export default TerminAbsageRueckfrage;
